export function hankakuToZenkaku(str, replace = "") {
  return str.replace(/[-ー−―‐]/g, replace).replace(/[０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}